export const uuid = (): string => crypto.randomUUID();

